// Showcase events displayed when no real events exist in the database.
// These are NOT stored in the database — they are purely visual templates.
// They disappear automatically as soon as real events are created.

const showcaseEvents = [
  {
    event_id: "showcase_marathon_lyon",
    title: "Marathon de Lyon 2026",
    description: "Le marathon incontournable de Lyon ! Parcourez les rues de la capitale des Gaules sur un parcours plat et rapide, traversant les quartiers historiques de la Presqu'ile, le Parc de la Tete d'Or et les berges du Rhone. Ambiance garantie avec des milliers de spectateurs tout au long du parcours. Ravitaillements tous les 5km, chronometrage officiel et medaille finisher pour tous les participants.",
    sport_type: "running",
    location: "Lyon, Rhone",
    exact_address: "Place Bellecour, 69002 Lyon",
    latitude: 45.7578,
    longitude: 4.8320,
    date: "2026-05-17T08:00:00",
    end_date: "2026-05-17T18:00:00",
    max_participants: 5000,
    current_participants: 1847,
    price: 55,
    distances: ["42.195km", "21.1km", "10km"],
    races: [
      { race_id: "r1", name: "Marathon 42km", distance: "42.195km", price: 55, max_participants: 3000, current_participants: 1200, elevation_gain: 120 },
      { race_id: "r2", name: "Semi-Marathon 21km", distance: "21.1km", price: 35, max_participants: 2000, current_participants: 547, elevation_gain: 60 },
      { race_id: "r3", name: "10km Decouverte", distance: "10km", price: 20, max_participants: 3000, current_participants: 100, elevation_gain: 30 },
    ],
    image_url: "https://images.unsplash.com/photo-1596727362302-b8d891c42ab8?w=1200&q=80",
    themes: ["marathon", "route", "urbain"],
    has_timer: true,
    requires_medical_cert: true,
    requires_pps: false,
    status: "active",
    published: true,
    provided_items: ["tshirt", "medaille", "ravitaillement"],
    organizer_name: "Votre Nom d'Organisateur",
    website_url: "https://ibooksport.com",
    _isShowcase: true,
  },
  {
    event_id: "showcase_trail_alpes",
    title: "Trail des Alpes - Ultra Montagne",
    description: "Defiez les sommets alpins sur ce trail exigeant ! Trois distances pour tous les niveaux, des sentiers techniques en altitude avec des passages en crete et vue sur le Mont Blanc. Ravitaillements gourmands avec produits locaux. Un defi sportif inoubliable dans un cadre naturel exceptionnel. Chaque participant recoit un t-shirt technique et une medaille finisher.",
    sport_type: "running",
    location: "Chamonix, Haute-Savoie",
    exact_address: "Place du Triangle de l'Amitie, 74400 Chamonix",
    latitude: 45.9237,
    longitude: 6.8694,
    date: "2026-07-12T06:00:00",
    end_date: "2026-07-13T20:00:00",
    max_participants: 1500,
    current_participants: 623,
    price: 75,
    distances: ["80km", "45km", "20km"],
    races: [
      { race_id: "r4", name: "Ultra Trail 80km", distance: "80km", price: 95, max_participants: 300, current_participants: 178, elevation_gain: 5200 },
      { race_id: "r5", name: "Trail 45km", distance: "45km", price: 65, max_participants: 500, current_participants: 312, elevation_gain: 2800 },
      { race_id: "r6", name: "Rando Trail 20km", distance: "20km", price: 40, max_participants: 700, current_participants: 133, elevation_gain: 1200 },
    ],
    image_url: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&q=80",
    themes: ["trail", "montagne", "ultra"],
    has_timer: true,
    requires_medical_cert: true,
    requires_pps: true,
    status: "active",
    published: true,
    provided_items: ["tshirt", "medaille", "ravitaillement", "sac"],
    organizer_name: "Votre Nom d'Organisateur",
    _isShowcase: true,
  },
  {
    event_id: "showcase_triathlon_annecy",
    title: "Triathlon du Lac d'Annecy",
    description: "Le plus beau triathlon de France ! Nagez dans les eaux cristallines du lac d'Annecy, roulez sur les routes panoramiques de Haute-Savoie et courez le long des berges. Deux formats disponibles : distance olympique et sprint. Un cadre exceptionnel pour une epreuve sportive de haut niveau. Village depart avec stands partenaires et animations.",
    sport_type: "triathlon",
    location: "Annecy, Haute-Savoie",
    exact_address: "Plage d'Albigny, 74000 Annecy",
    latitude: 45.8992,
    longitude: 6.1294,
    date: "2026-08-30T08:00:00",
    end_date: "2026-08-30T16:00:00",
    max_participants: 1200,
    current_participants: 489,
    price: 65,
    distances: ["51.5km", "25.75km"],
    races: [
      { race_id: "r7", name: "Distance Olympique", distance: "51.5km (1.5/40/10)", price: 70, max_participants: 600, current_participants: 298, elevation_gain: 350 },
      { race_id: "r8", name: "Sprint", distance: "25.75km (0.75/20/5)", price: 50, max_participants: 600, current_participants: 191, elevation_gain: 150 },
    ],
    image_url: "https://images.unsplash.com/photo-1700649536739-850389d212c4?w=1200&q=80",
    themes: ["triathlon", "natation", "multisport"],
    has_timer: true,
    requires_medical_cert: true,
    requires_pps: false,
    status: "active",
    published: true,
    provided_items: ["tshirt", "medaille", "ravitaillement", "bonnet"],
    organizer_name: "Votre Nom d'Organisateur",
    _isShowcase: true,
  },
];

export default showcaseEvents;
